var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tour-exit" }, [
    _c(
      "button",
      {
        staticClass: "tour-exit__btn",
        on: {
          click: function ($event) {
            return _vm.$emit("quit")
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("tours.nav.quit")) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }